import React from 'react';
import PhoneNumberDisplay from '../PhoneNumberDisplay';

export interface AccountCellProps {
  name: string;
  email?: string;
  phone?: string;
}

const AccountCell: React.FC<AccountCellProps> = ({ name, email, phone }) => (
  <div style={{ lineHeight: 1.4 }}>
    <div style={{ fontWeight: 600 }}>{name || '-'}</div>
    {email && (
      <div style={{ color: '#6b7280', fontSize: 12 }}>
        {email}
      </div>
    )}
    {phone && (
      <div style={{ color: '#94a3b8', fontSize: 12 }}>
        <PhoneNumberDisplay value={phone} />
      </div>
    )}
  </div>
);

export default AccountCell;
